<template lang="pug">
  span
    slot(v-bind="{ loading, auth }")
</template>

<script>
import { SYSTEMS_API } from '@/modules/Auth/constants';

import { mapActions } from 'vuex';
import { apiService } from '@/services/APIService';
import JWTService from '@/services/JWTService';

export default {
  props: {
    redirect: {
      type: [String, Object],
      default: null,
    },
    noRedirect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      init: 'auth/init',
    }),
    async auth({ data } = {}) {
      if (!data) return;
      this.loading = true;
      JWTService.setToken(data?.access_token);
      JWTService.setRefreshToken(data?.refresh_token);

      await this.init();

      const userData = this.$user.data;
      const userSocials = userData.social?.map(({ type }) => type);

      if (userSocials.includes(userData.active_system)) {
        const authResponse = await this.$api.user
          .transferUser({
            type: userData.active_system,
          })
          .catch(() => null);
        if (authResponse?.data?.data) {
          apiService.changeApiUrl(SYSTEMS_API[userData.active_system]);
          JWTService.setToken(authResponse.data.data.access_token);
          JWTService.setRefreshToken(authResponse.data.data.refresh_token);
        }
      }
      if (!this.noRedirect) {
        const redirect = this.$route.query?.redirect || this.redirect || { name: 'main' };
        this.$router.push(redirect);
      }
      this.$emit('success');
      // this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
